import { METHOD_POST } from '../constants/apis';
import { STRAPI_URL } from '../constants/url';

export async function PostRecord(api: string, body: any) {
	let response = await fetch(`${STRAPI_URL}/api/${api}`, {
		method: METHOD_POST,
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(body),
	});

	if (!response.ok) {
		throw new Error(await response.text());
	}
	const responseData = await response.json();
	return responseData;
}
